import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import LazyLoad from 'react-lazyload';

import EquipmentMonthLoadWidget from '../../../components/widgets/equipment/month_load';

const ReportItem = ({equipment, selectedDate, convertedShift}) => {
  const {t} = useTranslation();
  let history = useHistory();

  const onItemClick = (id) => {
    history.push({
      pathname: `/report/equipment/${id}`,
    });
  };

  const onBarClick = (id, date) => {
    history.push({
      pathname: `/report/equipment/${id}`,
      search: `?date=${date}`
    });
  };
  
  return (
    <LazyLoad height={300} offset={100} once>
      <div className="flex h-full border border-gray-100 rounded-sm px-4 py-4 text-sm">
        <div className="w-full">
          <div className="flex justify-between h-8 items-center">
            <div className="flex space-x-1 cursor-pointer">
              <span className="font-medium">{equipment.attributes.name}</span><span>{equipment.attributes.inventory_number}</span>
              <span className="font-medium text-gray-500">({equipment.attributes.producer_name} {equipment.attributes.equipment_model_name})</span>
            </div>
            <button onClick={() => onItemClick(equipment.id)} className="px-2 py-1 bg-blue-100 rounded text-blue-700 font-medium text-sm">{t('more_details')}</button>
          </div>
          <div className="flex space-x-1 itmes-center h-6 items-center">
            <span className={`rounded bg-blue-50 text-xs px-2 leading-6`}>{t(equipment.attributes.status)}</span>
            <span className="font-medium text-gray-500 leading-6">{equipment.attributes.division_name}</span>
          </div>
          <div className="flex w-full h-80">
            <EquipmentMonthLoadWidget item={equipment} selectedDate={selectedDate} convertedShift={convertedShift} onBarClick={onBarClick}/>
          </div>
        </div>
      </div>
    </LazyLoad>
  )
}

export default ReportItem;